import React from "react";
import "./Footer.css";
const Footer = () => {
  const etisalatLogo = require("../assets/img/etisalat_logo_new.png");

  return (
    <div>
      <footer>
        <div className="footer-container">
          <div className="foot_top">
                <ul>
                  <li>
                    <a
                      href="https://www.etisalat.ae/en/footer/about-us.html"
                      target="_blank"
                    >
                      About us
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.etisalat.ae/content/dam/dx_eitsalat_ae/en/system/wst/assets/docs/consumer/general/code-of-conduct.pdf"
                      target="_blank"
                    >
                      Code of Conduct
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.etisalat.ae/en/footer/privacy-policy.html"
                      target="_blank"
                    >
                      Privacy Policy
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.etisalat.ae/en/footer/terms-and-conditions.html"
                      target="_blank"
                    >
                      Terms &amp; Conditions
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.etisalat.ae/en/footer/doing-business-with-us.html"
                      target="_blank"
                    >
                      Etisalat Tenders
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://careers.etisalat.ae/en/index.html"
                      target="_blank"
                    >
                      Careers
                    </a>
                  </li>
                </ul>
              </div>
            <div className="foot-of-footer">
              <div className="logowrp">
                <img
                  src={etisalatLogo}
                  className="img-fluid"
                />
              </div>
              <p className="copy_mob">© 2022 Etisalat. All Rights Reserved.</p>
            </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
